export const palette = {
    bluePrimary: "#042c4c",
    blueLight: "#eaf3ff",
    blueAccent: "#1976d2",

    black: "#000000",
    blackTransparent: "#00000014",

    gray50: "#fafafc",
    gray100: "#f2f2f5",
    cardHeader: "#F3F7FC",
    gray300: "#cfcfcf",
    gray400: "#b3b3b3",
    gray600: "#666",

    green: "#13c296",

    red: "#dc3545",

    orange: "#ffa500",

    yellow: "#f7e933",

    white: "#ffffff",
};
export const darkPalette = {
    bluePrimary: "#7BA3D4",
    blueLight: "#D9D8ED",
    blueAccent: "#354459",
    blueLightTransparent: "rgba(91, 155, 213, 0.25)",

    black: "#18171D",
    blackTransparent: "rgba(255, 255, 255, 0.08)",

    gray50: "#25242A",
    gray100: "#2d2d2d",
    cardHeader: "#2E3640",
    gray300: "#3B3848",
    gray400: "#404040",
    gray600: "#9e9e9e",
    gray700: "#3A383F",

    green: "#34A080",

    red: "#BF4C36",

    orange: "#D99531",

    yellow: "#f7e933",

    white: "#ffffff",

    inputBackground: "#3D3D42",
    secondaryButton: "#454449",
    secondaryButtonHover: "#615F64",
    primaryButton: "#5B9BD5",
    primaryButtonHover: "#9DC7F1",
    dangerButton: "#B84A3E",
    dangerButtonHover: "#CC5447",
};
